import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Law} from "../../models/laws";
import Helpers from "../../utils/helpers";

@Injectable()
export class LawControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getLawsList(): Observable<Law[]> {
    return this.http.get(this.baseUrl + "law") as Observable<Law[]>;
  }

  public getLaw(lawId: string): Observable<Law> {
    return this.http.get(this.baseUrl + "law/" + lawId) as Observable<Law>;
  }

  public saveLaw(law: Law) {
    Helpers.trimRecursiveObj(law);
    const body = JSON.stringify(law);
    return this.http.put(this.baseUrl + "law", body, {responseType: "text"});
  }

  public createLaw(law: Law) {
    Helpers.trimRecursiveObj(law);
    const body = JSON.stringify(law);
    return this.http.post(this.baseUrl + "law", body);
  }

  public deleteLaw(lawId: string) {
    return this.http.delete(this.baseUrl + "law/" + lawId, {responseType: "text"});
  }
}
